<template>
  <h1 class="sr-only">아티스트</h1>
  <!-- s::PAGE -->
  <div class="contents art-artist">
    <!-- s:: ART & ARTIST -->
    <div class="art-artist">
      <div class="list">
        <div class="layout">
          <div class="visual-slide">
            <div class="swiper visualSwiper">
              <div class="swiper-wrapper">
                <div v-show="banners.length == 0" class="swiper-slide"></div>
                <div class="swiper-slide" v-for="item in banners">
                  <figure
                      @click="goToBannerUrl(item.linkUrl)"
                      :style="{ cursor: item.linkUrl ? 'pointer' : 'default' }">
                    <template v-if="item.mediaType === 'MP4'">
                      <video autoplay muted loop playsinline>
                        <source :src="item.imageUrl" type="video/mp4">
                      </video>
                    </template>
                    <template v-else>
                      <img :src="item.imageUrl" :alt="item.title || '아티스트 배너'">
                    </template>
                  </figure>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>

          <div ref="artistsRef" class="filter-box">
            <div class="group-box">
              <SearchBar v-model="searchQuery" placeholder="아티스트 이름" @submit="onSearch"/>

              <!-- 정렬 방식 텍스트 -->
              <div class="sort-options">
                <span class="checkbox-type1">
                  <input type="checkbox" id="searchOnlyLike" v-model="searchOnlyLike" @change="toggleSearchOnlyLike">
                  <label for="searchOnlyLike" style="color: #999;">
                    관심 아티스트
                  </label>
                </span>
                <span v-for="(option, index) in ARTIST_LIST_SORT_OPTIONS" :key="index"
                      :class="{ selected: selectedSort.value === option.value }" @click="setSortOption(option)">
                  {{ option.label }}
                </span>
              </div>
            </div>

            <!-- 자음검색 제외 추후 적용.
            <div class="sort-box">
              <a v-for="(filter, index) in filters" :key="index" href="#" :class="{ on: selectedIndex === index }"
                @click.prevent="selectFilter(index)">
                {{ filter }}
              </a>
            </div> -->
          </div>

          <ul v-show="artists && artists.length > 0" class="ret-list">
            <li v-for="artist in artists" :key="artist.uuid">
              <!--              <router-link :to="{ name: 'ArtistDetail', params: { userAccountId: artist.userAccountId } }" >-->
              <a @click="beforeNavigate(artist.userAccountId)">
                <div class="txt">
                  <h3>{{ artist.nameEn }}</h3>
                  <p>{{ artist.nameKo }}</p>
                </div>
                <div class="img-box">
                  <figure>  <!--  class="arch-image"-->
                    <img :src="artist.imageUrl" :alt="artist.nameKo || artist.nameEn" loading="lazy"/>
                  </figure>
                </div>
              </a>
              <div class="chip-container" v-if="chipTargetIds.includes(artist.id)">
                <Chip>2025 통영아트위크</Chip>
              </div>
              <!--              </router-link>-->
              <HeartButton v-model:isLike="artist.isLike" :uuid="artist.uuid" likeType="ARTIST"/>
            </li>
          </ul>
          <ul v-show="searchQuery && !(artists && artists.length > 0)">
            <NoSearchResult/>
          </ul>
          <Pagination :current-page="currentPage" :total-pages="totalPages"
                      :visible-count="5" @goToPage="goToPage"/>
          <InfiniteScroll :on-reach-end="moreData" :current-page="currentPage"
                          :total-pages="totalPages" :is-fetching="isFetching"/>
        </div>
      </div>
    </div>
    <!-- e:: ART & ARTIST -->
  </div>
  <!-- e::PAGE -->
</template>
<script setup>
import { ARTIST_LIST_SORT_OPTIONS } from "@/common/common-enum";
import Chip from "@/components/ui/Chip.vue";
import HeartButton from "@/components/ui/HeartButton.vue";
import InfiniteScroll from "@/components/ui/InfiniteScroll.vue";
import NoSearchResult from "@/components/ui/NoSearchResult.vue";
import Pagination from "@/components/ui/Pagination.vue";
import SearchBar from "@/components/ui/SearchBar.vue";
import { useArtists } from "@/composables/useArtists";
import router from "@/router";
import { apiClient } from "@/services/auth-header";
import { useAuthStore } from "@/store/auth.module";
import { useDeviceStore } from "@/store/deviceStore";
import { useUiStore } from "@/store/useUiStore";
import { globalScrollStore } from "@/stores/scrollStore";
import { goToBannerUrl } from "@/utils/bannerLink";
import { SCROLL_LAYOUT, SCROLL_STORAGE_KEYS } from "@/utils/scrollConstants";
import Swiper from "swiper";
import { computed, onMounted, ref } from 'vue';
import { useRoute } from "vue-router";

const deviceStore = useDeviceStore();
const isMobile = computed(() => deviceStore.isMobile);

const uiStore = useUiStore();
const route = useRoute();
const authStore = useAuthStore();

// useArtists Composable 사용
const { artists, fetchArtists, currentPageData } = useArtists();


const banners = ref([]);
const mainSwiper = ref();
const selectedSort = ref({
  value: route.query.sort || ARTIST_LIST_SORT_OPTIONS[0].value,
  direction: route.query.direction || ARTIST_LIST_SORT_OPTIONS[0].direction
});
// const selectedIndex = ref(0); // 현재 선택된 인덱스 (미사용)
const artistsRef = ref(null);

// 페이지 정보
const searchOnlyLike = ref(route.query.like || false);
const searchQuery = ref(route.query.q || "");
const currentPage = ref(Number(route.query.page || 0));
const size = ref(24);
const totalPages = ref(0);
const isFetching = ref(false);

// 칩 표시 대상 ID 목록
const chipTargetIds = [139, 140, 141, 142, 143, 144, 145, 146];

// const filters = ['전체', 'ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ']; // 자음 검색용 (미사용)
// 자음 검색 기능 (현재 미사용)
// const selectFilter = (index) => {
//   selectedIndex.value = index;
//   searchQuery.value = index === 0 ? '' : filters[index];
//   setSortOption(ARTIST_LIST_SORT_OPTIONS[1])
// };

const beforeNavigate = async (userAccountId) => {
  // 네비게이션 전 스크롤 위치는 router.beforeEach에서 자동으로 저장됨
  await router.push({name: 'ArtistDetail', params: {userAccountId}});
};

const setSortOption = (sort) => {
  if (selectedSort.value.value != sort.value) {
    selectedSort.value = sort;
    goToPage(0); // 정렬 방식 변경 시 첫 페이지부터 다시 로딩
  }
};

const toggleSearchOnlyLike = () => {
  if (searchOnlyLike && !authStore.status.loggedIn) {
    searchOnlyLike.value = false;
    alert("로그인 후 이용 하실 수 있습니다.");
    return;
  }
  goToPage(0);
}

async function goToPage(page = 0) {
  if (process.env.NODE_ENV === 'development') {
    console.log('🔥 [GoToPage] Called with page:', page, 'current scroll:', window.scrollY);
  }
  
  // 현재 스크롤 위치를 저장 (뒤로가기용)
  globalScrollStore.savePosition(route.fullPath, window.scrollY);
  
  // 페이지네이션 플래그 설정 (sessionStorage + 메모리 플래그)
  try {
    sessionStorage.setItem(SCROLL_STORAGE_KEYS.PAGINATION_NAVIGATION, 'true');
  } catch (error) {
    console.warn('SessionStorage unavailable, using memory flag:', error);
  }
  
  // 메모리 플래그는 항상 설정 (sessionStorage 제한 환경 대응)
  if (window.setMemoryPaginationFlag) {
    window.setMemoryPaginationFlag(true);
  }

  // 네비게이션 전에 카드 섹션으로 스크롤
  if (artistsRef.value) {
    const cardSectionTop = artistsRef.value.offsetTop;
    if (process.env.NODE_ENV === 'development') {
      console.log('🔥 [GoToPage] Pre-navigation scroll to:', cardSectionTop);
    }
    window.scrollTo({
      top: cardSectionTop - SCROLL_LAYOUT.CARD_SECTION_OFFSET,
      behavior: 'auto'
    });
  }

  await router.push({
    name: route.name,
    query: {q: searchQuery.value, like: searchOnlyLike.value, page: page, sort: selectedSort.value.value, direction: selectedSort.value.direction}
  });
  
  if (process.env.NODE_ENV === 'development') {
    console.log('🔥 [GoToPage] Navigation completed');
  }
}

function moreData(page = 0, append = false) {
  fetchArtistsData(page, append);
}

function onSearch(query) {
  searchQuery.value = query;
  currentPage.value = 0;
  goToPage(0);
}

const fetchBanners = async () => {
  try {
    // V1 API 유지 (아직 V2로 마이그레이션되지 않음)
    const response = await apiClient.get('/v1/contents/banners', {
      params: {type: 'ART_ARTIST'}
    });
    banners.value = response.data;
  } catch (error) {
    console.error("Error fetching banners:", error);
  }
};

const fetchArtistsData = async (page = 0, append = false) => {
  if (isFetching.value) {
    return;
  }
  isFetching.value = true;

  try {
    // useArtists Composable 사용 (무한스크롤 지원)
    await fetchArtists({
      q: searchQuery.value,
      like: searchOnlyLike.value,
      page: page,
      size: size.value,
      sort: selectedSort.value.value,
      direction: selectedSort.value.direction
    }, append);
    
    // Composable에서 관리하는 currentPageData 사용
    if (currentPageData.value) {
      currentPage.value = currentPageData.value.pageable?.pageNumber ?? page;
      totalPages.value = currentPageData.value.totalPages || 0;
    }
  } catch (error) {
    console.error("Error fetching artists:", error);
    alert(error.message);
  } finally {
    isFetching.value = false;
  }
};

const setSwiper = async () => {
  mainSwiper.value = new Swiper('.visualSwiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: false,
    grabCursor: true, // 드래그할 때 손 모양의 커서 표시
    pagination: {
      el: ".swiper-pagination"
    },
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },
  }).init();
};

const init = async () => {
  uiStore.showLoading();
  await fetchBanners();
  await fetchArtistsData(currentPage.value);
  await setSwiper();
  
  // 페이지네이션 플래그 정리
  let isPaginationNavigation = false;
  try {
    isPaginationNavigation = sessionStorage.getItem(SCROLL_STORAGE_KEYS.PAGINATION_NAVIGATION) === 'true';
    if (process.env.NODE_ENV === 'development') {
      console.log('🔥 [Init] isPaginationNavigation from sessionStorage:', isPaginationNavigation);
    }
    
    if (isPaginationNavigation) {
      if (process.env.NODE_ENV === 'development') {
        console.log('🔥 [Init] Pagination navigation - cleaning up flag');
      }
      // 페이지네이션 플래그 제거 (스크롤은 goToPage에서 처리됨)
      sessionStorage.removeItem(SCROLL_STORAGE_KEYS.PAGINATION_NAVIGATION);
    }
  } catch (error) {
    console.warn('Failed to access sessionStorage for pagination flag:', error);
  }
  
  uiStore.hideLoading();
};

onMounted(async () => {
  if (isMobile.value) {
    currentPage.value = 0;
  }

  await init();
});

</script>

<style scoped>


.sort-options {
  display: flex;
  align-items: center;
  gap: 20px;
  /* 옵션 간의 간격 */
}

.sort-options span {
  cursor: pointer;
  font-size: clamp(14px, 2.0vw, 16px);
  color: #999;
  /* 기본 텍스트 색상 (회색) */
  transition: color 0.3s ease;
}

.sort-options span.selected {
  color: #ffc107;
  /* 선택된 텍스트 색상 (노란색) */
  font-weight: bold;
  /* 선택된 텍스트 강조 */
}

.sort-options .checkbox-type1 label {
  font-size: clamp(14px, 2.0vw, 16px);
}

/* 반응형 비디오 슬라이더 - 1620px 제한 */
.visual-slide {
  max-width: 1620px; /* 최대 너비 제한 */
  margin: 0 auto; /* 중앙 정렬 */
}

.visual-slide .swiper-slide figure {
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #000; /* 여백이 생길 경우 검은 배경 */
  width: 100%;
  height: 100%;
}

.visual-slide .swiper-slide video,
.visual-slide .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 컨테이너를 완전히 덮도록 */
  object-position: center;
}

/* 모든 슬라이드 내 이미지 가운데 정렬 */
.swiper-slide {
  display: flex;
  justify-content: center; /* 좌우 중앙 정렬 */
  align-items: center; /* 상하 중앙 정렬 */
  text-align: center; /* 텍스트 중앙 정렬 (선택사항) */
}

/* 1620px 제한된 배너의 기본 비율 - 간소화 */
.art-artist .visual-slide .swiper-slide figure {
  aspect-ratio: 1620 / 330; /* 1620px 기준 비율 */
  height: auto; /* aspect-ratio에 의해 자동 계산 */
}

/* 반응형 - 원본 비율 유지하며 자연스럽게 축소 */
@media (max-width: 1660px) {
  .visual-slide {
    margin: 0 20px; /* 좌우 여백 추가 */
  }
}

/* 리스트 아이템을 relative로 설정하여 chip의 absolute positioning 기준점으로 사용 */
.art-artist .list .ret-list li {
  position: relative;
}

/* Chip을 완전히 독립적으로 배치 - 기존 레이아웃에 영향 없음 */
.chip-container {
  position: absolute;
  top: 90px; /* 한글 이름(p 태그) 아래 적절한 간격 */
  left: 15px; /* 텍스트 시작점과 동일하게 정렬 */
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  opacity: 0.9;
  pointer-events: none; /* 클릭 이벤트가 하위 링크로 전달되도록 */
}

/* 반응형 - 모바일에서 위치 조정 */
@media (max-width: 768px) {
  .chip-container {
    top: 70px;
    left: 12px;
  }
}

/* 아티스트 이미지 흰색 선 문제 최소 수정 */
.art-artist .list .ret-list .img-box figure {
  background: transparent;
}

.art-artist .list .ret-list .img-box img {
  background: transparent;
}


</style>